<script>
  export let data;
  export let col = "words";

  const nameMap = { baby: "baby abeds" };

  $: filtered = data.filter((d) => d.name !== "other");
  $: other = data.find((d) => d.name === "other");
  $: max = Math.max(...filtered.map((d) => d[col]));
</script>

<ul>
  {#each filtered as d (d.name)}
    <li>
      <span class="name">{nameMap[d.name] || d.name}</span>
      <span
        class="value"
        style="width: {Math.round((d[col] / max) * 100)}%;"><strong>{d[col]}</strong></span>
    </li>
  {/each}
</ul>

<p class="note"><em>Not shown: {other[col]} from other characters.</em></p>

<style>
  ul {
    padding-left: 6em;
  }

  li {
    display: block;
    width: 100%;
    position: relative;
    line-height: 1;
    margin-bottom: 1em;
    font-size: 1em;
  }

  li:first-of-type strong {
    transform: translateX(0);
  }

  span {
    display: block;
  }

  .value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: rgba(221, 221, 221, 0.6);
    border: 1px solid var(--fg);
  }

  .name {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-100%, -50%);
    padding-right: 0.5em;
    text-transform: capitalize;
    margin-bottom: 0.25em;
  }

  strong {
    font-size: 0.75em;
    padding: 0.5em;
    transform: translateX(100%);
  }

  .note {
    text-align: center;
  }

  @media only screen and (min-width: 960px) {
    li:first-of-type strong {
      transform: translateX(100%);
    }

    ul {
      transform: translateX(-3em);
    }
  }
</style>
